<script setup lang="ts">
import dtwinService from "~/modules/dtwin/services/dtwin.service";

const props = defineProps<{
  dtwinUids: string | string[];
  organizationCode?: number;
  buttonClass?: string[];
}>();

defineEmits(["delete"]);

const { t } = useI18n();

const deleteFn: () => Promise<void> = () => {
  if (Array.isArray(props.dtwinUids)) {
    return dtwinService.bulkDeleteOrganizationDtwins(
      props.organizationCode,
      props.dtwinUids,
    );
  } else {
    return dtwinService.deleteOrganizationDtwin(
      props.organizationCode,
      props.dtwinUids,
    );
  }
};

const buttonClassComputed = computed(() => {
  const buttonClass = ["!px-0", "!py-0"];
  if (props.buttonClass) {
    buttonClass.push(...props.buttonClass);
  }
  return buttonClass;
});
</script>

<template>
  <delete-action
    :delete-fn="deleteFn"
    :title="t('dtwins.action.delete.tooltip')"
    :confirm-title="t('dtwins.action.delete.confirm.title')"
    :confirm-description="t('dtwins.action.delete.confirm.message')"
    :button-class="buttonClassComputed"
    @success="$emit('delete')"
  />
</template>
